import { api } from './client';
import { setToken } from '../auth/tokenStore';

interface LoginResponse {
  token: string;
  user: {
    userId: string;
    username?: string;
    displayName?: string;
  };
}

export async function login(username: string, password: string) {
  const res = await api.post<LoginResponse>('/api/login', { username, password });
  setToken(res.token);
  return res.user;
}

export async function fetchMe() {
  return api.get<{ userId: string; username?: string; displayName?: string }>('/api/users/me');
}
